import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TipoFirmante } from '../../../../envios/models/tipo-firmante';
import { FirmanteNif } from '../../../models/firmante-nif';
import { FormularioDocumentoService } from '../../../services/formulario-documento.service';
import { FormularioValidacionesDocsService } from '../../../services/formulario-validaciones-docs.service';

@Component({
  selector: 'app-configuracion-firmas-dibujada',
  templateUrl: './configuracion-firmas-dibujada.component.html',
  styleUrls: ['./configuracion-firmas-dibujada.component.css']
})
export class ConfiguracionFirmasDibujadaComponent implements OnInit {

  @Input() firmante: TipoFirmante;
  @Input() mostrarErrorSeleccion = false;
  tituloFirma:string='';

  constructor(public formularioDocumentoService: FormularioDocumentoService,
              public formularioValidacionesDocsService: FormularioValidacionesDocsService) { }

  ngOnInit(): void {
    if(this.formFirma.controls['tipoFirma'].value=='CERTIFICADO') this.tituloFirma='Certificado digital';
    else this.tituloFirma='Dibujada';
  }

  get formFirma(): FormGroup {
    return this.formularioDocumentoService.getFirmasGroup(this.firmante.codigo)!;
  }

  get tieneTag(){ return this.formFirma.get('tieneTag') }

  obtenerIndexNifArray(): number {
    return this.formularioDocumentoService.firmantesNif.value.findIndex(
      (x: FirmanteNif) => x.tipoFirmante.codigo === this.firmante.codigo
    );
  }
}
